import { css, CSSResult } from 'lit'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseStickyBar = {
  backgroundColor: css`var(--cse-sticky-bar-background-color, ${csColorBackground.primary})`,
  topBoxShadow: css`var(--cse-sticky-bar-top-box-shadow, ${csShadow.downSmall})`,
  bottomBoxShadow: css`var(--cse-sticky-bar-bottom-box-shadow, ${csShadow.upSmall})`,
  paddingInline: css`var(--cse-sticky-bar-padding-x, ${csSpacing.spacing06})`,
  paddingBlock: css`var(--cse-sticky-bar-padding-y, ${csSpacing.spacing06})`,
  offsetY: css`var(--cse-sticky-bar-offset-y, 0)`,
}

export const style: CSSResult = css`
  :host {
    background-color: ${cseStickyBar.backgroundColor};
    display: block;
    padding-block: ${cseStickyBar.paddingBlock};
    padding-inline: ${cseStickyBar.paddingInline};
    position: sticky;
    width: 100%;
  }

  :host([position="top"]) {
    box-shadow: ${cseStickyBar.topBoxShadow};
    top: ${cseStickyBar.offsetY};
  }

  :host([position="bottom"]) {
    box-shadow: ${cseStickyBar.bottomBoxShadow};
    bottom: ${cseStickyBar.offsetY};
  }
`
